import { lazy } from 'react';

/**
 * Lazy-loaded entry point. Code is only fetched when this module is imported,
 * which the App does conditionally — and only in dev — so the editor never
 * lands in the production bundle shipped to bundleport.com.
 */
export const FoliageEditor = lazy(() => import('./FoliageEditor'));

export function shouldShowFoliageEditor(): boolean {
  if (!import.meta.env.DEV) return false;
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('edit') === '1';
  } catch {
    return false;
  }
}
